import React from 'react'
import Tippy from '@tippyjs/react'
import clsx from 'clsx'
import { useDispatch, useSelector } from 'react-redux'

import { datatableTypes } from '@/typings'
import { datatableActions, datatableSelectors } from './store'

type Props = {
	dataKey: string
	children?: React.ReactNode
	headerAlign?: datatableTypes.DatatableColAlign
	tooltip?: string
	mediaWidth: number
}

const DatatableHeadCol = ({ children, dataKey, headerAlign, tooltip, mediaWidth }: Props) => {
	const dispatch = useDispatch()
	const { size, sort = true } = useSelector(datatableSelectors.getColByDataKey(dataKey))
	const isAsc = useSelector(datatableSelectors.isSortAsc(dataKey))
	const isDesc = useSelector(datatableSelectors.isSortDesc(dataKey))

	const handleSort = () => {
		if (!sort) {
			return
		}
		dispatch(datatableActions.updateSort({ dataKey }))
		dispatch(datatableActions.getData())
	}

	const returnContent = (
		<div
			className={clsx({ 'relative table-cell p-4': true, 'lg:w-auto': !size })}
			style={size && mediaWidth >= 1024 ? { width: `${size}px` } : {}}
		>
			<div
				className={clsx({
					'flex items-center': true,
					'justify-start text-left': headerAlign === 'start',
					'justify-center text-center': headerAlign === 'center',
					'justify-end text-right': headerAlign === 'end',
				})}
			>
				<button
					className={clsx({
						'font-bold': true,
						'cursor-default': !sort,
						'underline hover:no-underline cursor-pointer ': sort,
					})}
					onClick={handleSort}
					type="button"
				>
					{children}
					{isAsc && <div className="fas fa-caret-up ml-1" />}
					{isDesc && <div className="fas fa-caret-down ml-1" />}
					{sort && !isAsc && !isDesc && <div className="fas fa-sort ml-1" />}
				</button>
			</div>
		</div>
	)

	if (tooltip) {
		return <Tippy content={tooltip}>{returnContent}</Tippy>
	}

	return returnContent
}

export default DatatableHeadCol
